import { Text } from "@src/components/deprecated/Text/Text";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { FirebaseDataSelectField } from "to-be-removed/LocalData/General/DataObjectField/Generic/FirebaseDataSelectField";
import { DataObjectField, InputElementContext } from "../../../to-be-removed/LocalData/General/DataObjectField/DataObjectField";
import { DataObjectUtilities } from "../../../utils/dataObjectUtilities";
import { LoadingIndicator } from "../../ui-components/LoadingIndicator/LoadingIndicator";
import { ModalPopup } from "../ModalPopup/ModalPopup";

type Props<T> = {
  id: string;
  field: DataObjectField<T, any>;
  onFinish: (value: T | undefined) => void;
  defaultValue?: T | undefined;
  context?: InputElementContext;
  description?: string;
};

export const DataObjectFieldInput = ({ id, field, onFinish, defaultValue, context, description }: Props<any>) => {
  const [value, setValue] = useState<any>(defaultValue);
  const [, setLastUpdate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    if (field instanceof FirebaseDataSelectField) {
      field
        .loadAllDatas(context)
        .then(() => {
          setLastUpdate(new Date());
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [field]);

  const useCustomSort = field.key === "tags";

  return (
    <ModalPopup
      id={id}
      title={`${t("main.edit")} ${field.title.toLocaleLowerCase()}`}
      actionTitle={t("main.save")}
      onActionClicked={() => {
        onFinish(value);
      }}
    >
      <>
        {isLoading && <LoadingIndicator marginBottom={8} />}
        {description && (
          <Text textAlign="left" marginBottom={16}>
            {description}
          </Text>
        )}
        {field.inputElement?.(value, setValue, context, useCustomSort)}
      </>
    </ModalPopup>
  );
};
